<script>
	import { getAmount, getHeaders } from "../scripts/gSheets";
    import GraphBlock from "./components/GraphBlock.svelte";
    import Block from "./components/InfoBlock.svelte";
    import { currentAddress } from "../scripts/eth";

	let address = "";
    currentAddress.subscribe(val => address = val);


    let totalRewards = 0;
    let yestAPR = 0;
    let cumulativeRewards;
    let cumulativeAPR;
    let headers;
    let yestRewards = 10;
    let totalAPR = 0;
    let yestAPRTitle;
    let cumulativeRewardsTitle;

    let inList = true;

	async function getData() {
        // await boot(dispatch);
        // console.log('getData')
        // if (!isConnected) setTimeout(getData, 100);
        // else {
            const allHeaders = await getHeaders();
            headers = allHeaders[1];
            cumulativeAPR = allHeaders[0];

            let yestIndex = 0;
            for (let i = headers.length; i > 1; i--) {
                if (cumulativeAPR[i-1] != 0) {
                    yestIndex = i - 1;
                    break;
                }
            }

            yestAPR = cumulativeAPR[yestIndex];
            yestAPRTitle = yestAPR + "%";

            const allData = await getAmount(address);
            
            if (allData[0] == -1) {
                //address not in database
                inList = false;
                console.log('not in database');
                return;
            }
            
            // get yesterday's index

            yestRewards = '$' + allData[yestIndex];
            totalRewards = '$' + allData[allData.length-3];
            totalAPR =  (allData[allData.length-1] * 100).toFixed(0) + '%';
            cumulativeRewards = [];
            let sum = 0;
            for (let i = 0; i < allData.length-3; i++) {
                sum = sum + parseFloat(allData[i]);
                // console.log(parseFloat(allData[i]))
                cumulativeRewards.push(sum.toFixed(2));
            }

            yestAPRTitle = yestAPR + "%";
            cumulativeRewardsTitle = totalRewards;
	}

    let promise = getData();

    function handleGetData() {
        getData();
    }
</script>

<style>
    row {
        display: flex;
        flex-direction: row;
        justify-content: left;
        flex-wrap: wrap;
    }
    column {
        display: flex;
        flex-direction: column;;
        justify-content: left;
        flex-wrap: wrap;
    }
</style>

<main>
{#if (address != '' && address != '0x0')}
    {#await promise}
    <h1 style='margin: 30px'> Loading... </h1>
    {:then result}
        {#if inList}
            <row style="justify-content: space-around">
                <column>
                    <Block text="Total APR (Estimated)" amount = {totalAPR} color='orange'/>
                    <Block text="Total Rewards (Estimated)" amount = {totalRewards} color='green'/>
                    <Block text="Yesterday's Reward" amount = {yestRewards} color='blue'/>
                </column>
                <column style="flex-grow: 1">
                    <GraphBlock headers={headers} values={cumulativeRewards} title="Cumulative Rewards Earned (Estimated)" bigNum={cumulativeRewardsTitle}/>
                    <GraphBlock headers={headers} values={cumulativeAPR} title="Current IRO APR (Estimated)" bigNum={yestAPRTitle}/>
                </column>
            </row>
        {:else}
        <row>
            <GraphBlock headers={headers} values={cumulativeAPR} title="Current IRO APR" bigNum={yestAPRTitle}/>
            <Block text="This wallet hasn't participated in the IRO." isEmpty={true} color='black'/>
        </row>
        {/if}

    {/await}
{:else}
    <h1 style='margin: 30px'> Wallet not connected </h1>
{/if}
    
</main>